import { PracticeArea } from 'types/practice-areas';

/**
 * Ids of the subareas that sit right under their parent, or under a sibling that does, in list order. Under any
 * other order, or when the parent is not a row (soft-deleted), a subarea draws flat: indenting by level alone would
 * hang it under the unrelated row above it.
 */
export const nestedSubareaIds = (rows: PracticeArea[]): Set<number> => {
    const ids = new Set<number>();
    let runParentId: number | undefined;
    for (const pa of rows) {
        const parentId = pa.parentPracticeArea?.id;
        if (parentId == null) runParentId = pa.id;
        else if (parentId === runParentId) ids.add(pa.id);
        else runParentId = undefined;
    }
    return ids;
};
